import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Header from "../../Components/common/Header";
import Footer from "../../Components/common/Footer";
import { FaUsers, FaUserGraduate, FaLaptopCode, FaBookReader } from "react-icons/fa";
import "./Aboutus.css";

export default function Aboutus() {
  return (
    <>
      <Header />
      <div className="Aboutus-page" dir="rtl">
        {/* Banner Section */}
        <div className="about-banner text-center py-5">
          <Container>
            <h1 className="about-main-title fw-bold text-white mb-3">من نحن؟</h1>
            <p className="about-subtitle text-white-50">تعرف على منصة نوح التعليمية ورؤيتنا لمستقبل التعليم</p>
          </Container>
        </div>

        {/* Content Section */}
        <Container className="py-5 my-3">
          <Row className="align-items-center mb-5 g-5">
            <Col lg={5} className="text-center">
              <div className="about-logo-wrapper">
                <img
                  src="/LogoNohe.png"
                  alt="منصة نوح التعليمية"
                  className="img-fluid rounded-4 shadow-sm"
                  style={{ maxWidth: "320px", border: "4px solid var(--brand-100)" }}
                />
              </div>
            </Col>
            <Col lg={7} className="text-end">
              <h2 className="section-title mb-4">منصة نوح التعليمية المتكاملة</h2>
              <p className="lead text-muted mb-4">
                تأسست منصة نوح التعليمية برؤية طموحة لتكون المنصة التعليمية المتكاملة الرائدة في مصر، حيث تجمع نخبة من أفضل وأقوى المعلمين والأساتذة المتخصصين في كافة المواد الدراسية لطلاب الثانوية العامة والأزهرية.
              </p>
              <p className="mb-3">
                نهدف في المنصة إلى إعادة تعريف أساليب التعلم من خلال دمج التكنولوجيا الحديثة مع خبرات المعلمين التربوية العريقة. نسعى لتبسيط المناهج الدراسية، وتعميق الفهم الأكاديمي، وتدريب الطلاب على أنماط التفكير النقدي والاستنباط بدلاً من الحفظ والتلقين.
              </p>
              <p className="mb-4">
                تحتوي المنصة على مجموعة واسعة من الكورسات التفاعلية، والامتحانات الذاتية، ومتابعة الأداء المستمر لضمان تميز الطلاب وتأهيلهم للالتحاق بأعرق الجامعات.
              </p>
            </Col>
          </Row>

          {/* Core Values / Features */}
          <h3 className="text-center fw-bold mb-5 mt-5">ما الذي يميز منصة نوح؟</h3>
          <Row className="g-4">
            <Col md={6} lg={3}>
              <Card className="feature-card border-0 h-100 shadow-sm text-center p-4">
                <div className="feature-icon-box mb-3 mx-auto">
                  <FaUsers size={32} />
                </div>
                <Card.Title className="fw-bold fs-5 mb-2">نخبة من كبار المعلمين</Card.Title>
                <Card.Text className="text-muted small">
                  تضم المنصة معلمين متميزين ذوي خبرة واسعة وقدرة عالية على تبسيط المناهج وتوجيه الطلاب نحو التميز.
                </Card.Text>
              </Card>
            </Col>

            <Col md={6} lg={3}>
              <Card className="feature-card border-0 h-100 shadow-sm text-center p-4">
                <div className="feature-icon-box mb-3 mx-auto">
                  <FaLaptopCode size={32} />
                </div>
                <Card.Title className="fw-bold fs-5 mb-2">تعلم ذكي وتفاعلي</Card.Title>
                <Card.Text className="text-muted small">
                  شرح بأحدث الوسائل التكنولوجية وتصوير عالي الجودة مع توفير بيئة تعليمية مرنة وبسيطة.
                </Card.Text>
              </Card>
            </Col>

            <Col md={6} lg={3}>
              <Card className="feature-card border-0 h-100 shadow-sm text-center p-4">
                <div className="feature-icon-box mb-3 mx-auto">
                  <FaBookReader size={32} />
                </div>
                <Card.Title className="fw-bold fs-5 mb-2">متابعة مستمرة وتقييم</Card.Title>
                <Card.Text className="text-muted small">
                  اختبارات دورية بعد كل درس لمتابعة تطور الطالب الأكاديمي وضمان استيعاب كافة أجزاء المنهج.
                </Card.Text>
              </Card>
            </Col>

            <Col md={6} lg={3}>
              <Card className="feature-card border-0 h-100 shadow-sm text-center p-4">
                <div className="feature-icon-box mb-3 mx-auto">
                  <FaUserGraduate size={32} />
                </div>
                <Card.Title className="fw-bold fs-5 mb-2">خدمة دعم أكاديمي</Card.Title>
                <Card.Text className="text-muted small">
                  فريق دعم مخصص للإجابة على أسئلة واستفسارات الطلاب بانتظام ومساعدتهم على المذاكرة بشكل فعال.
                </Card.Text>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
}
